import React from 'react'
import {
  Button,
  useColorModeValue,
  Text
} from '@chakra-ui/react'

const Answer = ({ answer, updateSelection, qid, isSelected, isCorrect, quizOver }) => {
  let bgColor = 'blue'
  let variant = 'outline'
  let color = useColorModeValue('black', 'white')
  let boxShadow = 'none'
  let answerFontSize = 'md'
  if(answer.length > 56) {
    answerFontSize= 'xs'
  }
  if(isSelected) {
    color='white'
  }
  if(quizOver) {
    if (isCorrect) {
      //console.log(`${answer} is correct!`)
      color = 'white'
      bgColor = 'green'
      variant = 'solid'
      if(isSelected) {
        boxShadow = '0px 1px 25px -5px rgb(66 225 153 / 48%), 0 10px 10px -5px rgb(66 225 153 / 43%)'
      }
    }
    else if (isSelected) {
      bgColor = 'red'
      variant = 'solid'
    }
}
  return (
    <Button
      whiteSpace={'normal'}
      maxW={'100%'}
      colorScheme={bgColor}
      onClick={() =>updateSelection(qid, answer)}
      isDisabled={quizOver}
      isActive={isSelected}
      boxShadow={boxShadow}
      rounded={'full'}
      variant={variant}
      color={color}
      _disabled={{
        opacity: '0.8'
      }}
      _active={!quizOver && {
        bg: 'blue.400'
      }}>
      <Text fontSize={answerFontSize} overflowWrap={'break-word'} maxW={'100%'} fontWeight={'400'} dangerouslySetInnerHTML={{__html:answer}}></Text>
    </Button>

    
  )
}

export default Answer